<div class="navigation-map-container d-flex">
	<mat-icon class="cursor-pointer" (click)="navigateToHome()">home</mat-icon>

	@if (activeRoute && activeRoute.id) {
	<mat-icon>chevron_right</mat-icon>
	<span>{{ 'NAVBAR.' + activeRoute.id | translate }}</span>
	}
</div>
